var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MemolifeLogo"},[(_vm.showHeart)?_c('div',{staticClass:"heart"}):_vm._e(),_c('div',{staticClass:"text"})])}
var staticRenderFns = []

export { render, staticRenderFns }